import { NewsAddIcon } from '../../Brand/Icon';
import React from "react";
import { APP_ROUTES } from '../../../utils/constant';
import url from '../../../utils/url';
import { getUser } from '../../../utils/func';
import { AnimatedLink } from '../AnimatedLink';
import { useTranslation } from 'react-i18next';

export default function ButtonStoryAdd() {
	const { t } = useTranslation();
	let user = getUser();
	const src = url(user ? APP_ROUTES.STORY_ADD : APP_ROUTES.LOGIN);
	
	return (
		<AnimatedLink aria-label={t('story.add')} to={src}>
			<NewsAddIcon className="nav-icon" />
		</AnimatedLink>
	)
}
